import { get } from '@/utils/request'
import Script from 'next/script'
import { useCallback, useEffect, useState } from 'react'

type PropType = {
  res: Share.WxShare | undefined
}
// 直接通过链接点进去进行转发，微信是不允许的。
// 1. 必须通过二维码等扫码进入。或者通过公众号入口进入的项目才行。
// 2. 先收藏，然后再打开收藏的链接，然后再次进行分享
const WechatShare: React.FC<PropType> = ({ res }) => {
  const [isWxLoadSuccess, setWxLoad] = useState(false)
  const isProduction = process.env.NODE_ENV !== 'development'

  const configJsSDK = useCallback(() => {
    get(`wx_official_accounts`, { url: window.location.href.split('#')[0] }).then((jsSDK: Share.JsSDK) => {
      if (wx) {
        wx.config({
          appId: jsSDK.app_id,
          timestamp: jsSDK.timestamp,
          nonceStr: jsSDK.nonce_str,
          signature: jsSDK.signature,
          jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'],
        })
      }
    })
  }, [])

  const configShare = useCallback((res: Share.WxShare) => {
    if (res) {
      document.title = res.title
      let sharedTitle = res.title && res.title.includes('.') ? res.title.substring(0, res.title.lastIndexOf('.')) : ''
      sharedTitle = sharedTitle || res.title
      const sharedDesc = res.share_abstract && res.show_custom_share ? res.share_abstract : res.title
      wx.ready(() => {
        wx.updateAppMessageShareData({
          title: sharedTitle,
          desc: sharedDesc,
          link: window.location.href.split('#')[0],
          imgUrl: res.share_cover && res.show_custom_share ? res.share_cover : `${window.location.origin}/lingti-gd-logo.png`,
          success() {},
        })
        wx.updateTimelineShareData({
          title: sharedTitle,
          link: window.location.href.split('#')[0],
          imgUrl: res.share_cover && res.show_custom_share ? res.share_cover : `${window.location.origin}/lingti-gd-logo.png`,
          success() {},
        })
      })
    }
  }, [])

  useEffect(() => {
    if (isProduction && window.wx && res) {
      configJsSDK()
      configShare(res)
    }
  }, [configJsSDK, isProduction, isWxLoadSuccess, configShare, res])

  return (
    <div>
      <Script src="https://res2.wx.qq.com/open/js/jweixin-1.6.0.js" strategy="afterInteractive" onLoad={() => setWxLoad(true)} />
    </div>
  )
}

export default WechatShare
